import { createContext } from 'react';

export const global = createContext();
export const info = createContext();